import React from 'react';

export default function Navigation(props) {
  return (
    <nav className="navbar_container noselect">
        <div className="around_row navbar_content_1">
          <div className="navbarDiv" onClick={() => props.setMenu(props.menu === 'Presentation' ? '' : 'Presentation')}>
            <p
              style={{
                color: props.menu === 'Presentation' ? '#18E161' : props.menu ===  '' ? 'lightgrey' : '#989AA6',
                borderBottom: props.menu === 'Presentation' ? '1px solid #18E161' : 'none',
                }}
              className="navbarTextLink">Presentation</p>
          </div>
          <div className="navbarDiv" onClick={() => props.setMenu(props.menu === 'Gallery' ? '' : 'Gallery')}>
            <p
              style={{color: props.menu === 'Gallery' ? '#18E161' : props.menu ===  '' ? 'lightgrey' : '#989AA6',
                borderBottom: props.menu === 'Gallery' ? '1px solid #18E161' : 'none',
                }}
              className="navbarTextLink">Gallery</p>
          </div>
          <div className="navbarDiv" onClick={() => props.setMenu(props.menu === 'Booking' ? '' : 'Booking')}>
            <p
              style={{color: props.menu === 'Booking' ? '#18E161' : props.menu ===  '' ? 'lightgrey' : '#989AA6',
                borderBottom: props.menu === 'Booking' ? '1px solid #18E161' : 'none',
                }}
              className="navbarTextLink">Booking</p>
          </div>
        </div>
        <div className="around_row navbar_content_2">
          <div
            className="navbarDiv" onClick={() => props.setMenu(props.menu === 'Tours' ? '' : 'Tours')}>
            <p
              style={{color: props.menu === 'Tours' ? '#18E161' : props.menu ===  '' ? 'lightgrey' : '#989AA6',
                borderBottom: props.menu === 'Tours' ? '1px solid #18E161' : 'none',
                }}
              className="navbarTextLink">Tours</p>
          </div>
          <div className="navbarDiv" onClick={() => props.setMenu(props.menu === 'Comments' ? '' : 'Comments')}>
            <p
              style={{color: props.menu === 'Comments' ? '#18E161' : props.menu ===  '' ? 'lightgrey' : '#989AA6',
                borderBottom: props.menu === 'Comments' ? '1px solid #18E161' : 'none',
                }}
              className="navbarTextLink">Comments</p>
          </div>
        </div>
      </nav>
  )
}
